<script setup>
// import { storeToRefs } from 'pinia'
import { Select } from 'primevue'
import { ref, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'

import { useUserStore } from '@/stores/user.js'

const store = useUserStore()
// const { dark, lang } = storeToRefs(store)
const { availableLocales } = useI18n()
const { t } = useI18n()

// Users menu
const menu = ref(null)
const items = ref([])

watchEffect(() => {
  // When there is a uses logged in
  if (store.username) {
    items.value = []
    // TODO: esto solo si es administrador: obtener ese dato del store
    if (store.perms.users_read) {
      items.value.push({
        label: t('Administration'),
        items: [
          {
            label: t('User list'),
            icon: 'pi pi-at',
            route: { name: 'UserList' }
          }
        ]
      })
    }
    items.value.push({
      label: t('Profile') + ' ' + store.username,
      items: [
        {
          label: t('Profile'),
          icon: 'pi pi-user-edit',
          route: { name: 'UserProfile' }
        },

        {
          label: t('Logout'),
          icon: 'pi pi-sign-out',
          route: { name: 'logout' }
        }
      ]
    })
  } else {
    items.value = [
      {
        label: t('Login'),
        icon: 'pi pi-sign-in',
        route: { name: 'login' }
      }
    ]
  }
})

const toggle = (event) => {
  menu.value.toggle(event)
}
</script>

<template>
  <Toolbar class="">
    <template #start>
      <div class="flex items-center gap-2">
        <router-link :to="{ name: 'home' }">
          <Button label="Marga" text plain />
        </router-link>
        <template v-if="store.username">
          <Button v-slot="slotProps" text plain as-child>
            <RouterLink :to="{ name: 'ProjectList' }" :class="slotProps.class">{{ t('Projects') }}</RouterLink>
          </Button>
          <Button v-slot="slotProps" text plain as-child>
            <RouterLink :to="{ name: 'CompanyList' }" :class="slotProps.class">{{ t('Companies') }}</RouterLink>
          </Button>
          <Button v-slot="slotProps" text plain as-child>
            <RouterLink :to="{ name: 'basetest-list' }" :class="slotProps.class"
              >{{ t('Ground investigations') }}</RouterLink
            >
          </Button>
        </template>
      </div>
    </template>

    <template #center> </template>

    <template #end>
      <div class="flex items-center gap-4">
        <ToggleButton v-model="store.dark" class="w-20" :on-label="t('Dark')" :off-label="t('Light')" />
        <Select id="lang" v-model="store.lang" :options="availableLocales" />
        <div>
          <span v-if="store.username" class="mr-1">{{ store.username }}</span>
          <Button
            type="button"
            icon="pi pi-user"
            severity="secondary"
            rounded
            aria-haspopup="true"
            aria-controls="overlay_menu"
            @click="toggle"
          />
          <Menu id="overlay_menu" ref="menu" :model="items" :popup="true">
            <template #item="{ item, props }">
              <router-link v-slot="{ href, navigate }" :to="item.route" custom>
                <a v-ripple :href="href" v-bind="props.action" @click="navigate">
                  <span :class="item.icon" />
                  <span class="ml-2">{{ item.label }}</span>
                </a>
              </router-link>
            </template>
          </Menu>
        </div>
      </div>
    </template>
  </Toolbar>
</template>

<style scoped></style>
